import {
  createSlice,
  createEntityAdapter,
  //createAsyncThunk,
  //createSelector,
} from '@reduxjs/toolkit'


const pagedEnquiryAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
  //sortComparer: (a, b) => 0-(a.id - b.id)
})

const initialState = pagedEnquiryAdapter.getInitialState({
  status: 'idle',
  type: undefined,
  criteria:{},
  pageNumber:0,
  pageSize:10,
  totalRecords:0,
});


const pagedEnquirySlice = createSlice({
  name: 'pagedEnquiry',
  initialState: initialState,
  reducers: 
  {
      clearEnquiries(state, action) {
          state.type=undefined
          state.status='idle'
          state.criteria={}
          state.pageNumber=0
        state.pageSize=10
        state.totalRecords=0
          pagedEnquiryAdapter.removeAll(state)
      },
      
      entriesSyncLoaded:
      {
          reducer(state, action) 
          {
            
            state.type=action.payload.type
            state.status='succeeded'
            state.pageNumber=action.payload.pageNumber
            state.pageSize=action.payload.pageSize
            state.totalRecords=action.payload.totalRecords
            state.criteria=action.payload.criteria
            pagedEnquiryAdapter.setAll(action.payload.data)
      
          },
          prepare(type, data, criteria,pageNumber,pageSize, totalRecords) 
          {
              let xx = {type, data, criteria,pageNumber,pageSize, totalRecords}
                return {payload:xx}
          }
      },
  
  }
})


export const { clearEnquiries, entriesSyncLoaded } = pagedEnquirySlice.actions

export default pagedEnquirySlice.reducer;

export const {
  selectAll:  selectAllEnquiries,
  selectById: xselectEnquiryById,
  selectIds:  selectEnquirIds,
} = pagedEnquiryAdapter.getSelectors((state) => state.pagedEnquiry)

export const selectEnquirById = (id)=>(state)=>xselectEnquiryById(state, id)
export const selectEnquirStatus = (state)=>state.pagedEnquiry.status;
export const selectEnquirType = (state)=>state.pagedEnquiry.type;
export const selectEnquirPageNumber  = (state)=>state.pagedEnquiry.pageNumber;
export const selectEnquirPageSize  = (state)=>state.pagedEnquiry.pageSize;
export const selectEnquirCriteria  = (state)=>state.pagedEnquiry.Criteria;

